module.exports = __webpack_public_path__ + "static/img/IMG_20150306_144905.8c8735e1.jpg";